import { render, staticRenderFns } from "./expanded-menu.vue?vue&type=template&id=57386875&"
import script from "./expanded-menu.vue?vue&type=script&lang=js&"
export * from "./expanded-menu.vue?vue&type=script&lang=js&"
import style0 from "./expanded-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports